<div class="container">
    <div class="row">
        <div class="col-lg-2"></div>
        <div class="col-lg-8">
            <syn-contact-form (onClick)="onContactSend($event)" [ApplicationId]="applicayionId"></syn-contact-form>
        </div>
        <div class="col-lg-2"></div>
    </div>
</div>

<synergy-footer></synergy-footer>
<p-toast [style]="{marginTop: '100px'}" position="top-center" key="tc" [hideTransitionOptions]="'1ms'">
</p-toast>